<main class="enl-pricing-v2" [attr.data-billing]="billing">

    <!-- HERO -->
    <section class="enl-pricing-v2__hero">
        <div class="enl-shell">
            <div class="enl-hero-grid">

                <div class="enl-hero-copy">
                    <span class="enl-eyebrow">
                        <span class="enl-eyebrow__dot"></span>
                        Built for faster Ro-Ro decisions
                    </span>

                    <h1>
                        Find better Ro-Ro options faster — and move bookings forward</h1>

                    <p class="enl-hero-copy__lede">
                        ENL Solutions brings schedules, port activity, pricing insight, rate requests, tracking, and
                        analytics
                        into one platform, helping your team spend less time searching and more time acting.
                    </p>

                    <div class="enl-hero-copy__actions">
                        <button class="enl-btn enl-btn--primary" (click)="openEnquiry()">Start free trial</button>
                        <button class="enl-btn enl-btn--secondary" (click)="openEnquiry()">Book demo</button>
                    </div>
                    <div class="enl-trial-strip" role="note" aria-label="Trial details">
                        <strong>14-day free trial</strong>
                        <span>No credit card. Get hands-on access to Route Finder, schedules, port visibility, and core
                            rate workflows before you commit.</span>
                    </div>

                    <ul class="enl-hero-points" aria-label="Core value points">
                        <li>Find scheduled port calls across 15+ global Ro-Ro carriers</li>
                        <li>Compare vessels, trade lanes, ports, and shipping lines updated daily</li>
                        <li>Send rate requests faster and keep commercial work moving</li>
                        <li>Add tracking, analytics, and team workflows as your operation grows</li>
                    </ul>
                </div>

                <!-- SIDE PANEL -->
                <aside class="enl-hero-panel">
                    <div class="enl-hero-panel__card">
                        <div class="enl-hero-panel__top">
                            <!-- <p class="enl-hero-panel__label">Why teams choose ENL</p> -->
                            <span class="enl-chip">Why teams choose ENL</span>
                            <span class="enl-chip">Built for commercial speed</span>
                        </div>
                        <h2>Stop chasing scattered Ro-Ro information</h2>
                        <p>
                            Use one place to search sailings, see port activity, request rates, and support operations
                            with
                            better visibility across the shipment lifecycle.
                        </p>
                        <div class="enl-hero-metrics">
                            <div class="enl-metric-card">
                                <strong>Find options faster</strong>
                                <span>Search routes, schedules, and port calls in one workflow.</span>
                            </div>
                            <div class="enl-metric-card">
                                <strong>Quote with more confidence</strong>
                                <span>Use pricing visibility and rate requests to move on opportunities sooner.</span>
                            </div>
                            <div class="enl-metric-card">
                                <strong>Scale across teams</strong>
                                <span>Add multi-user access, analytics, tracking, and rollout support when
                                    needed.</span>
                            </div>
                        </div>

                    </div>
                </aside>

            </div>
        </div>
    </section>

    <!-- PLANS -->
    <section class="enl-pricing-v2__plans" id="plans">
        <div class="enl-shell">
            <div class="enl-section-head enl-section-head--split">
                <div>
                    <p class="enl-section-head__eyebrow">Plans</p>
                    <h2>Choose the plan that matches how your team works</h2>
                    <p class="enl-section-head__text">
                        Start with core search and schedule visibility, move into shared workflows for daily company
                        use,
                        or choose a tailored rollout for larger operations.
                    </p>
                </div>

                <div class="enl-billing-toggle" role="group" aria-label="Billing frequency">
                    <button class="enl-billing-toggle__btn is-active" type="button"
                        [class.is-active]="billing === 'monthly'" (click)="setBilling('monthly')"
                        data-billing-option="monthly">Monthly</button>
                    <button class="enl-billing-toggle__btn" type="button" [class.is-active]="billing === 'annual'"
                        (click)="setBilling('annual')" data-billing-option="annual">Annual</button>
                </div>
            </div>

            <div class="enl-plan-grid">
                <article class="enl-plan-card">
                    <p class="enl-plan-card__eyebrow">Best for 1 user</p>
                    <h3>Professional</h3>
                    <p class="enl-plan-card__copy">
                        For operators and smaller teams that want faster route search, clearer schedules, and the
                        visibility
                        needed to respond quickly on live Ro-Ro opportunities.
                    </p>

                    <!-- <div class="enl-plan-price" aria-live="polite">
                        <strong>{{ getValue('€99', '€79') }}</strong>
                        <span>{{ getValue('/ user / month', '/ user / month billed annually') }}</span>
                    </div> -->
                    <p class="enl-plan-card__subprice" data-monthly="Fast, low-friction access"
                        data-annual="Billed annually at €948 per user">Fast, low-friction access</p>

                    <ul class="enl-plan-list">
                        <li>Unlimited Route Finder and schedule search</li>
                        <li>Port activity and pricing visibility</li>
                        <li>Rate request access</li>
                        <li>Email support</li>
                    </ul>

                    <div class="enl-plan-card__actions">
                        <a class="enl-btn enl-btn--ghost" data-cta="startTrial" data-track="professional-start-trial"
                            href="javascript:void(0)" (click)="openEnquiry()">Start free trial</a>
                    </div>
                </article>

                <article class="enl-plan-card enl-plan-card--featured">
                    <div class="enl-plan-card__badge">Most popular</div>
                    <p class="enl-plan-card__eyebrow">Best for growing teams</p>
                    <h3>Business</h3>
                    <p class="enl-plan-card__copy">
                        For freight forwarders, agents, OEM teams, and commercial users who need ENL as a daily working
                        tool for search, quoting, coordination, and better decision-making.
                    </p>

                    <!-- <div class="enl-plan-price" aria-live="polite">
                        <strong>FROM {{ getValue('€399', '€349') }}</strong>
                        <span>{{ getValue('/ month', '/ month billed annually') }}</span>
                    </div> -->
                    <p class="enl-plan-card__subprice" data-monthly="Built for active company use"
                        data-annual="Annual contracts from €4,188">Built for active company use</p>

                    <ul class="enl-plan-list">
                        <li>Everything in Professional</li>
                        <li>Multi-user team access</li>
                        <li>Quotation workflows, notifications, and analytics</li>
                        <li>Priority onboarding and support</li>
                    </ul>

                    <div class="enl-plan-card__actions enl-plan-card__actions--dual">
                        <a class="enl-btn enl-btn--primary" data-cta="bookDemo" data-track="business-book-demo" (click)="openEnquiry()"
                            href="javascript:void(0)">Book demo</a>
                        <a class="enl-btn enl-btn--ghost" data-cta="contactSales" data-track="business-contact-sales" (click)="openEnquiry()"
                            href="javascript:void(0)">Contact sales</a>
                    </div>
                </article>

                <article class="enl-plan-card">
                    <p class="enl-plan-card__eyebrow">Best for larger operations</p>
                    <h3>Enterprise</h3>
                    <p class="enl-plan-card__copy">
                        For shipping lines, ports, and larger logistics organizations that need tracking, advanced
                        analytics,
                        tailored workflows, and a commercial setup built around the business.
                    </p>

                    <div class="enl-plan-price enl-plan-price--custom">
                        <strong>Custom</strong>
                        <span>annual</span>
                    </div>
                    <p class="enl-plan-card__subprice">Tailored annual agreements</p>

                    <ul class="enl-plan-list">
                        <li>Tracking and advanced analytics</li>
                        <li>Tailored onboarding and rollout support</li>
                        <li>Custom workflow configuration</li>
                        <li>Dedicated commercial terms and support</li>
                    </ul>

                    <div class="enl-plan-card__actions">
                        <a class="enl-btn enl-btn--ghost" data-cta="bookDemo" data-track="enterprise-book-demo" (click)="openEnquiry()"
                            href="javascript:void(0)">Book demo</a>
                    </div>
                </article>
            </div>

            <div class="enl-business-strip">
                <div>
                    <strong>Need multi-user access, annual billing, or a tailored rollout?</strong>
                    <p>We will help you match the right plan to your team size, workflow, and operational goals.</p>
                </div>
                <a class="enl-btn enl-btn--primary enl-btn--small" data-cta="contactSales"
                    data-track="strip-contact-sales" href="javascript:void(0)" (click)="openEnquiry()">Contact sales</a>
            </div>
        </div>
    </section>

    <section class="enl-pricing-v2__section" id="compare">
        <div class="enl-shell">
            <div class="enl-section-head">
                <p class="enl-section-head__eyebrow">Compare</p>
                <h2>See what each plan unlocks</h2>
                <p class="enl-section-head__text">
                    Every plan is designed to help Ro-Ro teams work faster. Upgrade when you need shared access, deeper
                    workflows, advanced visibility, or rollout support.
                </p>
            </div>

            <div class="enl-compare-table-wrap" aria-hidden="false">
                <table class="enl-compare-table">
                    <thead>
                        <tr>
                            <th scope="col">Capability</th>
                            <th scope="col">Professional</th>
                            <th scope="col">Business</th>
                            <th scope="col">Enterprise</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">Best for</th>
                            <td>Solo users and small teams</td>
                            <td>Commercial and operational teams</td>
                            <td>Large organizations and tailored rollouts</td>
                        </tr>
                        <tr>
                            <th scope="row">Users</th>
                            <td>1 user</td>
                            <td>Multi-user access</td>
                            <td>Company-wide setup</td>
                        </tr>
                        <tr>
                            <th scope="row">Route &amp; schedule search</th>
                            <td>Included</td>
                            <td>Included</td>
                            <td>Included</td>
                        </tr>
                        <tr>
                            <th scope="row">Port calendars &amp; pricing insight</th>
                            <td>Included</td>
                            <td>Included</td>
                            <td>Included</td>
                        </tr>
                        <tr>
                            <th scope="row">Rate request workflows</th>
                            <td>Included</td>
                            <td>Advanced workflow support</td>
                            <td>Tailored workflow support</td>
                        </tr>
                        <tr>
                            <th scope="row">Notifications &amp; analytics</th>
                            <td>—</td>
                            <td>Included</td>
                            <td>Advanced</td>
                        </tr>
                        <tr>
                            <th scope="row">Tracking</th>
                            <td>—</td>
                            <td>Optional / on request</td>
                            <td>Included</td>
                        </tr>
                        <tr>
                            <th scope="row">Onboarding</th>
                            <td>Email support</td>
                            <td>Priority onboarding</td>
                            <td>Tailored rollout</td>
                        </tr>
                        <tr>
                            <th scope="row">Billing</th>
                            <td>Annual</td>
                            <td>Annual</td>
                            <td>Annual contract</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="enl-compare-mobile">
                <details class="enl-compare-mobile__item" open>
                    <summary>Professional</summary>
                    <ul>
                        <li><strong>Best for:</strong> Solo users and small teams</li>
                        <li><strong>Users:</strong> 1 user</li>
                        <li><strong>Search:</strong> Route and schedule search included</li>
                        <li><strong>Port calendars &amp; pricing:</strong> Included</li>
                        <li><strong>Rate workflows:</strong> Included</li>
                        <li><strong>Onboarding:</strong> Email support</li>
                        <li><strong>Billing:</strong> Monthly or annual</li>
                    </ul>
                </details>

                <details class="enl-compare-mobile__item">
                    <summary>Business</summary>
                    <ul>
                        <li><strong>Best for:</strong> Commercial and operational teams</li>
                        <li><strong>Users:</strong> Multi-user access</li>
                        <li><strong>Search:</strong> Route and schedule search included</li>
                        <li><strong>Port calendars &amp; pricing:</strong> Included</li>
                        <li><strong>Rate workflows:</strong> Advanced workflow support</li>
                        <li><strong>Analytics:</strong> Included</li>
                        <li><strong>Billing:</strong> Monthly or annual</li>
                    </ul>
                </details>

                <details class="enl-compare-mobile__item">
                    <summary>Enterprise</summary>
                    <ul>
                        <li><strong>Best for:</strong> Large organizations and tailored rollouts</li>
                        <li><strong>Users:</strong> Company-wide setup</li>
                        <li><strong>Search:</strong> Route and schedule search included</li>
                        <li><strong>Rate workflows:</strong> Tailored workflow support</li>
                        <li><strong>Tracking:</strong> Included</li>
                        <li><strong>Analytics:</strong> Advanced</li>
                        <li><strong>Billing:</strong> Annual contract</li>
                    </ul>
                </details>
            </div>
        </div>
    </section>

    <section class="enl-pricing-v2__section" id="segments">
        <div class="enl-shell">
            <div class="enl-section-head">
                <p class="enl-section-head__eyebrow">Built for</p>
                <h2>Designed for the teams that keep Ro-Ro cargo moving</h2>
                <p class="enl-section-head__text">
                    Whether you are finding sailings, quoting freight, or following vessel activity, ENL helps teams
                    move from searching to action with less manual work.
                </p>
            </div>

            <div class="enl-segment-grid">
                <article class="enl-segment-card">
                    <h3>Freight forwarders &amp; agents</h3>
                    <p>Find route options faster, check schedules and port calls, and respond to customers with stronger
                        information.</p>
                </article>
                <article class="enl-segment-card">
                    <h3>Shipping lines &amp; OEM teams</h3>
                    <p>Give commercial and operations teams shared visibility across sailings, requests, and
                        performance.</p>
                </article>
                <article class="enl-segment-card">
                    <h3>Ports, terminals &amp; partners</h3>
                    <p>Use tailored access to support planning, coordination, and visibility around vessel and port
                        activity.</p>
                </article>
                <article class="enl-segment-card">
                    <h3>Growing internal teams</h3>
                    <p>Start with one user, then expand into shared workflows, analytics, and tracking as usage grows.
                    </p>
                </article>
            </div>
        </div>
    </section>

    <section class="enl-pricing-v2__section" id="faq">
        <div class="enl-shell">
            <div class="enl-faq-panel">
                <div class="enl-section-head">
                    <p class="enl-section-head__eyebrow">FAQ</p>
                    <h2>Questions before you start?</h2>
                    <p class="enl-section-head__text">
                        Here are the answers most buyers need before starting a trial or choosing the right plan.
                    </p>
                </div>

                <div class="enl-faq-grid">
                    <details open>
                        <summary>Do I need a credit card for the free trial?</summary>
                        <p>No. The trial is designed to let you experience the platform before you commit.</p>
                    </details>
                    <details>
                        <summary>Which plan is right for one user or a small team?</summary>
                        <p>Professional is the simplest starting point when one user or a small team needs core search,
                            schedules, port visibility, and rate request access.</p>
                    </details>
                    <details>
                        <summary>When should we move to Business?</summary>
                        <p>Choose Business when multiple people need access or when quoting, notifications, and
                            analytics become part of the daily workflow.</p>
                    </details>
                    <details>
                        <summary>Do you offer multi-user access?</summary>
                        <p>Yes. Multi-user access is available in Business and Enterprise.</p>
                    </details>
                    <details>
                        <summary>Do you support annual billing?</summary>
                        <p>Yes. Annual billing is available for Professional and Business, while Enterprise is handled
                            through tailored annual agreements.</p>
                    </details>
                    <details>
                        <summary>Can ENL be tailored for larger operations?</summary>
                        <p>Yes. Enterprise is built for larger organizations that need rollout support, tailored
                            workflows, advanced analytics, tracking, and commercial terms aligned to the business.</p>
                    </details>
                </div>
            </div>
        </div>
    </section>

    <section class="enl-pricing-v2__cta">
        <div class="enl-shell">
            <div class="enl-final-cta-card">
                <div>
                    <p class="enl-section-head__eyebrow enl-section-head__eyebrow--light">Get started</p>
                    <h2>Start using ENL Solutions to find, quote, and move faster</h2>
                    <p>
                        Begin with a free trial or book a demo to discuss the right setup for your team, workflow, and
                        growth plans.
                    </p>
                </div>
                <div class="enl-final-cta-card__actions">
                    <a class="enl-btn enl-btn--primary" data-cta="startTrial" data-track="final-start-trial"
                        href="javascript:void(0)" (click)="openEnquiry()">Start free trial</a>
                    <a class="enl-btn enl-btn--secondary" data-cta="bookDemo" data-track="final-book-demo" href="javascript:void(0)" (click)="openEnquiry()">Book
                        demo</a>
                </div>
            </div>
        </div>
    </section>

    <div class="enl-mobile-cta" aria-label="Quick actions">
        <a class="enl-btn enl-btn--primary enl-btn--small" data-cta="startTrial" data-track="mobile-start-trial"
            href="javascript:void(0)" (click)="openEnquiry()">Start trial</a>
        <a class="enl-btn enl-btn--ghost enl-btn--small" data-cta="bookDemo" data-track="mobile-book-demo" href="javascript:void(0)" (click)="openEnquiry()">Book
            demo</a>
    </div>

</main>